import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { openExternal } from 'global/viewSettings/helpers/settingsLinks';
import _ from 'lodash';
import { seasonalHelpers } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/seasonalHelpers';
import { useMatchUpdate } from 'projectSpecific/sports/useHelpers/useMatchUpdate';
import { _allowSportsUpdates, useSeasonalData } from 'projectSpecific/sports/useHelpers/useSeasonals';
import { useContext, useEffect, useState } from 'react';
import { updateArrayInclusion } from '../../../../global/common/sorting';
import UiSaveButtons from '../../../../global/components/buttons/UiSaveButtons';
import DataPaste from '../../../../global/components/pasting/DataPaste';
import FullPageWrapper from '../../../../global/wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper';
import { SportsEditMatchContext } from '../../cnr/contexts/SportsEditMatchContext';
import { SportsMatchContext } from '../../cnr/contexts/SportsMatchContext';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { matchExternalTypes, matchModifyTypes, matchUpdateTypes } from '../../cnr/reducers/SportsSeasonReducer';
import { sportsHelpers } from '../../cnr/reducers/reducerHelpers/sportsHelpers';
import MatchForm from './MatchForm';
import MatchPlayoffPending from './MatchPlayoffPending';

const MatchDetailsUpdate = (props) => {

  const { match } = props ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { appUser_state, paps_state, currentSettings_state } = states
  const { appUser } = appUser_state ?? {}
  const { pathViews } = paps_state ?? {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext
  const { currentSeason_info, teams_info, matches_info, sportPermissions } = sportsSeason_state ?? {}
  const { matches, matches_playoffs } = matches_info ?? {}
  const { teams } = teams_info ?? {}
  const { latestSeason, sportsKey } = currentSeason_info ?? {}

  // sportsMatchContext
  const sportsMatchContext = useContext(SportsMatchContext)
  const { sportsMatch_state } = sportsMatchContext ?? {}
  const { matchDataUpdates, newMatchDate, match_true } = sportsMatch_state ?? {}

  // sportsEditMatchContext
  const sportsEditMatchContext = useContext(SportsEditMatchContext)
  const { sportsEditMatch_state, sportsEditMatch_handlers } = sportsEditMatchContext ?? {}
  const { matchPendingUpdate, match_edit, matchUpdateType: mut } = sportsEditMatch_state ?? {}
  const { matchUpdateType } = matchPendingUpdate ?? {}

  const _matchUpdateType = mut || matchUpdateType

  const { updateMatchDetails, updateMatchHistory, updating } = useMatchUpdate()
  const _seasonalDataHelpers = useSeasonalData()

  console.log('updating', updating)

  const match_actual = match_edit || match_true || match

  const { _itemKey } = match_actual ?? {}

  const _updateStatus = _allowSportsUpdates.seasonals && sportPermissions?.any && sportPermissions?.parentKeySportsData ? true : false

  // eslint-disable-next-line 
  const [matchReady, setMatchReady] = useState()
  const [winnerMatches, setWinnerMatches] = useState()

  useEffect(() => {
    if (!sportsEditMatch_handlers) return;
    switch (_matchUpdateType) {
      case matchUpdateTypes.updatePendingMatch:
        const pendings = {
          levelMatchUpdates: {},
          matchWinners: {},
          matchLosers: {},
          results: {},
        }
        sportsHelpers.getPendingMatchInfo(match_actual, matches_playoffs, pendings, teams)
        setWinnerMatches(pendings.matchWinners)
        sportsEditMatch_handlers.handleSet_matchDataUpdates(pendings.levelMatchUpdates)
        break;
      case matchUpdateTypes.updatePrePendingMatch:
        const { data_match } = sportsHelpers.getPrePendingMatches(match_actual, matches_playoffs)
        sportsEditMatch_handlers.handleSet_matchDataUpdates(data_match)
        break;
      default:
      // nothing
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);


  const [selectedMatchKeys, setSelectedMatchKeys] = useState([])

  const handleItemData = (itemData) => sportsEditMatch_handlers.handleCreate_matchesFromList({ itemData, teams, matches })

  const openExt = async () => {
    const pks = seasonalHelpers.getPks(pathViews, latestSeason, sportsKey, ['teams'])
    const _sportsYearCollectionItem = await _seasonalDataHelpers.getSports_collectionItem(pks, '_matches_seasonal', true)
    const { _itemKey } = _sportsYearCollectionItem ?? {}
    const { isPlayoff } = match_actual ?? {}
    const coll = isPlayoff ? 'playoffMatches' : 'matches'
    openExternal.db(pathViews, false, ['_matches_seasonal', _itemKey, coll, match_actual?._matchCollectionKey])
  }

  const handleCommit_matchDetails = () => {
    const cb = () => {
      // sportsSeason_handlers.handleUpdate_sportsSeasonTs()
    }

    switch (_matchUpdateType) {
      case matchExternalTypes.openDatabase:
        openExt()
        return;
      case matchModifyTypes.addToHistory:
        updateMatchHistory({ match: match_actual })
        return;
      case matchUpdateTypes.updateVideoUrl:
        updateMatchDetails({ matchUpdateType: _matchUpdateType, match: match_actual, callback: cb })
        return;
      default:
        updateMatchDetails({ matchUpdateType: _matchUpdateType, match: match_actual, callback: cb })
      // nothing
    }

  }

  const handleSelectedMatchKeys = (matchKey) => {
    const _selectedMatchKeys = [...selectedMatchKeys]
    updateArrayInclusion(_selectedMatchKeys, matchKey)
    setSelectedMatchKeys(_selectedMatchKeys)
  }

  const optsList = []
  if (teams) {
    const teamsS = _.sortBy(teams, 'name')
    teamsS.forEach(team => {
      optsList.push(
        {
          key: team.id,
          value: team.id,
          text: team.name
        }
      )
    })
  }

  const form_details = (videoUrlOnly) => <MatchForm match_edit={match_actual} shows={{ showDate: true, showTeams: false, showLocation: true, showVideoUrl: videoUrlOnly }} setMatchReady={setMatchReady} />
  const form_fullDetails = () => <MatchForm match_edit={match_actual} shows={{ showDate: true, showTeams: true, showLocation: true, showLevel: true }} setMatchReady={setMatchReady} />
  const form_results = () => <DataPaste handleItemData={handleItemData} />
  const form_url = (videoUrlOnly) => <MatchForm match_edit={match_actual} shows={{ showVideoUrl: videoUrlOnly }} setMatchReady={setMatchReady} />

  const match_pending = () => {
    if (winnerMatches) {
      return <div>
        <MatchPlayoffPending matches={winnerMatches} handleSelectedMatchKeys={handleSelectedMatchKeys} selectedMatchKeys={selectedMatchKeys} />
        <div>{JSON.stringify(matchDataUpdates)}</div>
      </div>
    }
  }

  const match_prePending = () => {
    if (matchDataUpdates) {
      return <div>
        <div>{JSON.stringify(matchDataUpdates)}</div>
      </div>
    }
  }

  const pending = () => {

    let content = 'Confirmation of Action: ' + _.startCase(_matchUpdateType) + '?'

    switch (_matchUpdateType) {
      case matchUpdateTypes.updateScore:
        if (matchPendingUpdate?.realtimeMatch?.currentResults) {
          content += ' (' + matchPendingUpdate.realtimeMatch.currentResults.scoreDisplays.full + ')?'
        }
        break;
      case matchModifyTypes.addToHistory:
        content = 'Confirm: Add to History?'
        break;
      case matchUpdateTypes.updateMatchDayMatch:
        content = 'Update Match Day Match?'
        break;
      case matchUpdateTypes.updatePendingMatch:
        content = match_pending()
        break;
      case matchUpdateTypes.updatePrePendingMatch:
        content = match_prePending()
        break;
      case matchUpdateTypes.editMatchDetails:
        content = form_details()
        break;
      case matchUpdateTypes.updateVideoUrl:
        content = form_url(true)
        break;
      case matchUpdateTypes.editFullMatchDetails:
        content = form_fullDetails()
        break;
      // case matchUpdateTypes.updateMatchListResults:
      //   content = form_results()
      //   break;
      case matchUpdateTypes.confirmMatchDate:
        content += 'Update Match Date? (' + newMatchDate + ')?'
        break;
      case matchUpdateTypes.updateGsScore:
        content += 'Update GS Score?'
        break;
      default:
        break;
    }

    const isDisabled = () => {
      if (!_allowSportsUpdates.matches) return true;
      switch (_matchUpdateType) {
        case matchUpdateTypes.updatePendingMatch:
          return matchDataUpdates && Object.keys(matchDataUpdates).length > 0 ? false : true
        case matchUpdateTypes.deleteMatch:
          return false
        default:
          return false
      }
    }

    const footer = () => <UiSaveButtons
      save={{
        oc: handleCommit_matchDetails,
        caption: _.startCase(_matchUpdateType),
        icon: isDisabled() ? 'arrow right' : 'save',
        color: _updateStatus && !isDisabled() ? 'green' : 'teal',
      }}
    />

    return <Wrapper
      content={content}
      footer={footer()}
      wrapperType={wrapperTypes.padded}
      updating={updating}
      css={{ container: 'app-dark-mode' }}
    />
  }

  const fullPageWrapper = () => <FullPageWrapper
    content={pending()}
    topperCaption={_.startCase(_matchUpdateType)}
    topperCaption2={_itemKey}
    updating={updating}
    handleCancel={props.handleCancel}
  />

  return props.handleCancel ? fullPageWrapper() : pending()
}

export default MatchDetailsUpdate